<!-- alert-confirm.component.html -->

<ng-container *ngIf="state$ | async as state">

  <div
    class="modal fade show d-block custom-modal"
    tabindex="-1"
    *ngIf="state.visible"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content shadow-lg border-0">

        <!-- Header -->
        <div class="modal-header bg-{{state.theme}} text-white">

          <h5 class="modal-title">

            <i
              class="bi"
              [ngClass]="{
                'bi-check-circle-fill': state.theme === 'success',
                'bi-input-cursor-text': state.theme === 'danger',
                'bi-exclamation-triangle-fill': state.theme === 'warning',
                'bi-info-circle-fill': state.theme === 'info'
              }"
            ></i>

            {{ state.title }}

          </h5>

          <button
            type="button"
            class="btn-close btn-close-white"
            (click)="alertService.close()"
          ></button>

        </div>

        <!-- Body -->
        <div class="modal-body">

          <div class="w-100">

            <p class="fs-5 text-center mb-4">
              {{ state.message }}
            </p>

            <!-- Input Field -->
            <div *ngIf="state.input.enabled">

              <label
                *ngIf="state.input.label"
                class="form-label fw-semibold"
              >
                {{ state.input.label }}
              </label>

              <input
                class="form-control"
                [type]="state.input.type"
                [placeholder]="state.input.placeholder || ''"
                [ngModel]="state.input.value"
                (ngModelChange)="alertService.updateInputValue($event)"
              />

              <div
                class="text-danger small mt-2"
                *ngIf="
                  state.input.required &&
                  !state.input.value
                "
              >
                This field is required.
              </div>

            </div>

          </div>

        </div>

        <!-- Footer -->
        <div class="modal-footer justify-content-center">

          <!-- Alert -->
          <button
            *ngIf="state.type === 'alert'"
            class="btn btn-{{state.theme}} px-4"
            (click)="alertService.close()"
          >
            OK
          </button>

          <!-- Confirm -->
          <ng-container *ngIf="state.type === 'confirm'">

            <button
              class="btn btn-secondary px-4"
              (click)="alertService.cancelAction()"
            >
              Cancel
            </button>

            <button
              class="btn btn-{{state.theme}} px-4"
              (click)="alertService.confirmAction()"
              [disabled]="
                state.input.required &&
                !state.input.value
              "
            >
              Confirm
            </button>

          </ng-container>

        </div>

      </div>
    </div>
  </div>

  <!-- Backdrop -->
  <div
    class="modal-backdrop fade show"
    *ngIf="state.visible"
  ></div>

</ng-container>